import { AbstractModel, isNullOrUndefined, DateUtil } from '@uzurv/core';
import { inheritSerialization, autoserializeAs, autoserialize } from 'cerialize';

@inheritSerialization(AbstractModel)
export class OfflineRouteNode extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserialize
  reservationStatusName: string;

  @autoserialize
  driverId: number;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserializeAs(Date)
  timestamp: Date;

  @autoserialize
  deviceInstallationId: number;

  // Local

  @autoserialize
  clientUUID: string;

  /**** Serialization ****/

  static OnSerialized(instance: OfflineRouteNode, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.timestamp)) {
      json.timestamp = DateUtil.serializeInstant(instance.timestamp);
    }

    // Make sure there isn't too much precision for database
    if (!isNullOrUndefined(instance.latitude)) {
      json.latitude = parseFloat(instance.latitude.toFixed(6));
    }
    if (!isNullOrUndefined(instance.longitude)) {
      json.longitude = parseFloat(instance.longitude.toFixed(6));
    }
  }

  static OnDeserialized(instance: OfflineRouteNode, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['timestamp'])) {
      instance.timestamp = DateUtil.deserializeInstant(json['timestamp']);
    }
  }

  /**** Comparison ****/

  equals(routeNode: OfflineRouteNode): boolean {
    if (!isNullOrUndefined(this.id) && this.id === routeNode.id) {
      return true;
    }

    if (!isNullOrUndefined(this.clientUUID) && this.clientUUID === routeNode.clientUUID) {
      return true;
    }

    // Don't recreate a status change or there there will be a backend error
    if (!isNullOrUndefined(this.reservationId) && !isNullOrUndefined(this.reservationStatusName)) {
      return this.reservationId === routeNode.reservationId && this.reservationStatusName === routeNode.reservationStatusName;
    }

    return (
      this.reservationId === routeNode.reservationId &&
      this.reservationStatusName === routeNode.reservationStatusName &&
      this.latitude === routeNode.latitude &&
      this.longitude === routeNode.longitude &&
      this.timestamp === routeNode.timestamp
    );
  }
}
